const my = {
  '赞助和游戏责任': 'Penajaan dan Tanggungjawab Permainan',
'产品': 'Produk',
'游戏': 'Permainan',
"踏入刺激，今天就在我们的在线游戏中试试你的运气吧！刺激和奖励等着你!": 'Langkahkan kaki ke dalam keseronokan dan cuba nasib anda dalam permainan dalam talian kami hari ini! Keseronokan dan ganjaran menanti anda!',
'排名': 'Kedudukan',
"更多的": "Lagi",
"拱廊": "Arked",
"撞车游戏": "Permainan Kemalangan",
"钓鱼游戏": "Permainan Memancing",
"直播": "Siarkan Langsung",
"登录": "Log Masuk",
"注册": 'Daftar',
"选择语言": 'Bahasa',
"介绍人": "Pengenal",
"账号": "Akaun",
"密码": "Kata Laluan",
"确认密码": "Sahkan Kata Laluan",
"真实姓名": "Nama",
"手机号码": "Nombor Telefon",
"取款密码": "Kata Laluan Pengeluaran",
"验证码": "Kod",
"请输入密码": "Sila masukkan kata laluan",
"请输入验证码": "Sila masukkan kod pengesahan",
"请输入账号": "Sila masukkan akaun",
"请重新获取验证码": "Sila dapatkan semula kod pengesahan",
"正在登录中": "Sedang log masuk",
"网络异常,请稍后再试": "Ralat rangkaian, sila cuba lagi kemudian",
"账号名": "Nama Akaun",
"余额": "Baki",
"会员中心": "Pusat Ahli",
"网上存款": "Deposit Dalam Talian",
"网上提款": "Pengeluaran Dalam Talian",
"退出": "Keluar",
"请再次输入密码": "Sila masukkan kata laluan sekali lagi",
"请输入姓名": "Sila masukkan nama anda",
"请输入手机号": "Sila masukkan nombor telefon anda",
"请输入取款密码": "Sila masukkan kata laluan pengeluaran",
"正在注册中": "Sedang mendaftar",
"确定": "Tentukan",
"注册成功": "Pendaftaran berjaya",
"热门优惠": "Diskaun Popular",
"首页": "Laman Utama",
"查看活动": "Lihat Aktiviti",
"正在获取活动列表": "Sedang mendapatkan senarai aktiviti",
"暂无活动": "Tiada aktiviti buat masa ini",
"活动详情": "Butiran Acara",
"视讯直播": "Penyiaran video langsung",
"直播类型": "Jenis penyiaran langsung",
"热门": "Popular",
"推荐": "Disyorkan",
"最新": "Terkini",
"全部": "Semua",
"获取类型中": "Sedang mendapatkan jenis",
"获取具体信息中": "Sedang mendapatkan maklumat terperinci",
"开始": "Mulakan",
"正在获取资源": "Sedang mendapatkan sumber",
"正在努力加载中": "Sedang cuba memuatkan",
"电子": "Elektron",
"大厅": "Dewan",
"游戏类型": "Jenis Permainan",
"游戏标签": "Tag Permainan",
"错误的类型": "Jenis Salah",
"返回首页": "Laman Utama",
"正在获取游戏列表": "Sedang mendapatkan senarai permainan",
"暂无游戏": "Tiada permainan buat masa ini",
"当前未登录,请先登录": "Belum log masuk, sila log masuk terlebih dahulu",
"联系我们": "Hubungi Kami",
"导航": "Navigasi",
"配置文件信息": "Maklumat Profil",
"常用功能": "Fungsi Biasa",
"充值": "Caj semula",
"提现": "Pengeluaran",
"功能列表": "Senarai Fungsi",
"交易": "Transaksi",
"设置": "Tetapkan",
"修改登入密码": "Tukar Kata Laluan Log Masuk",
"修改提现密码": "Tukar Kata Laluan Pengeluaran",
"银行卡": "Kad Bank",
"若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "Jika anda log masuk ke laman web melalui nombor telefon atau platform sosial, sila hubungi khidmat pelanggan untuk bantuan",
"旧密码": "Kata Laluan Lama",
"请输入旧密码": "Sila masukkan kata laluan lama anda",
"设定新密码": "Tetapkan kata laluan baru",
"确认新密码": "Sahkan kata laluan baru",
"确认": "Sahkan",
"下一步": "Langkah Seterusnya",
"交易功能": "Fungsi Dagangan",
"支付方式": "Kaedah Pembayaran",
"充值教学": "Pengajaran Caj Semula",
"选择渠道": "Pilih saluran",
"存款金额": "Jumlah Deposit",
"实际金额": "Jumlah Sebenar",
"提现币种": "Mata Wang Pengeluaran",
"提现银行卡": "Pengeluaran Kad Bank",
"新增": "Tambah Baru",
"提现金额": "Jumlah Pengeluaran",
"提现金额范围": "Julat Jumlah Pengeluaran",
"请输入金额": "Sila masukkan jumlah",
"实际到帐": "Jumlah Sebenar",
"一般手续费": "Yuran Pengendalian Umum",
"强制手续费": "Yuran Pengendalian Wajib",
"上一步": "Langkah Sebelumnya",
"修改成功": "Berjaya Diubah",
"修改中": "Sedang Diubah",
"拼命加载中": "Sedang Memuatkan dengan Pantas",
"编辑登录密码": "Edit Kata Laluan Log Masuk",
"编辑提款密码": "Edit Kata Laluan Pengeluaran",
"如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "Jika anda log masuk ke laman web melalui nombor telefon atau platform sosial, sila hubungi khidmat pelanggan untuk bantuan.",
"请输入新密码": "Sila masukkan kata laluan baru",
"新密码不能和旧密码一致": "Kata laluan baru tidak boleh sama dengan kata laluan lama",
"两次输入密码不一致!": "Kata laluan yang dimasukkan dua kali tidak sepadan!",
"请输入提款密码": "Sila masukkan kata laluan pengeluaran",
"输入提款密码": "Masukkan kata laluan pengeluaran",
"请设置新的提款密码": "Sila tetapkan kata laluan pengeluaran baru",
"设置6位提款密码，并记住您的密码": "Tetapkan kata laluan pengeluaran 6 digit dan ingat kata laluan anda",
"请输入新的提款密码": "Sila masukkan kata laluan pengeluaran baru",
"存款": "Deposit",
"取款": "Mengeluarkan",
"付款方式": "Kaedah Pembayaran",
"存款金额": "Jumlah Deposit",
"请输入金额": "Sila masukkan jumlah",
"下一步": "Langkah seterusnya",
"提款金额": "Jumlah Pengeluaran",
"提款银行卡": "Kad Bank Pengeluaran",
"请输入您的银行卡号": "Sila masukkan nombor kad bank anda",
"切换语言将会刷新页面": "Menukar bahasa akan menyegarkan halaman",
"充值方式": "Kaedah Caj Semula",
"取消": "Pembatalan",
"登录过期,是否重新登录": "Log masuk tamat, adakah anda mahu log masuk semula",
"系统提示": "Dibantu",
"国家": "Negara",
"请输入": "Sila masukkan",
"请选择": "Sila pilih",

  "加载更多": "Muat lebih banyak",
"开始": "Main",
"存取款": "Deposit",
"加钱": "Tambah wang",
"选择您的奖金": "Pilih bonus anda",
"100%,最高1500": "100% hingga R$1,500",
"CASINO": "CASINO",
"Select your lottery": "Pilih loteri anda",
"don't want a lottery": "tidak mahu loteri",
"金额不得小于": "Jumlah tidak boleh kurang dari",
"金额不得大于": "Jumlah tidak boleh lebih dari",
"加载失败": "Gagal memuatkan",
"活动中心": "Pusat Aktiviti",
"**财富攀升-BRL的充值促销**": "**Pendakian Kekayaan - Promosi Tambahan dalam BRL**",
"在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "Dalam acara unik ini, kami menyediakan peluang tanpa henti untuk anda mengumpul kekayaan. Sama ada anda seorang pemula atau pengguna berpengalaman, setiap tambah nilai akan membawa anda hadiah pelbagai peringkat dan keistimewaan yang lebih tinggi.",
"**青铜级别（青铜）**": "**Tahap Gangsa (Bronze)**",
"-重新加载的总金额：1.000-5.000 BRL": "- Jumlah tambah nilai keseluruhan: 1.000 - 5.000 BRL",
"-礼品的比例从5%逐渐增加到10%": "- Peratusan hadiah meningkat dari 5% hingga 10%",
"-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "- Pada tambah nilai pertama, anda akan menerima hadiah eksklusif. Pintu ke arah kekayaan terbuka. Dengan setiap tambah nilai tambahan, lebih banyak hadiah akan diterima.",
"**银级（银级）**": "**Tahap Perak (SILVER)**",
"-重新加载的总金额：5.001-15.000 BRL": "- Jumlah tambah nilai keseluruhan: 5.001 - 15.000 BRL",
"-礼品的比例从10%逐渐增加到15%": "- Peratusan hadiah meningkat dari 10% hingga 15%",
"-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "- Anda telah mencapai tahap Perak di mana kekayaan anda terus berkembang. Lebih banyak anda tambah nilai, lebih tinggi nisbah hadiah. Tambah nilai lebih banyak, peroleh lebih banyak!",
"**黄金级别（Gold）**": "**Tahap Emas (GOLD)**",
"-重新加载的总金额：15.001-30.000 BRL": "- Jumlah tambah nilai keseluruhan: 15.001 - 30.000 BRL",
"-礼品的比例从15%逐渐增加到18%": "- Peratusan hadiah meningkat dari 15% hingga 18%",
"-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "- Anda berada di jalan bangsawan yang penuh kekayaan. Dengan menjadi ahli Emas, anda akan menerima lebih banyak hadiah yang murah hati. Kekayaan anda ditakdirkan untuk berkembang.",
"**白金级别（白金）**": "**Tahap Platinum (PLATINUM)**",
"-随着冷却值的增加，会奖励更多的礼物": "- Dengan peningkatan nilai penyejukan, lebih banyak hadiah akan diberikan",
"-重新加载的总金额：30.001-60.000 BRL": "- Jumlah tambah nilai keseluruhan: 30.001 - 60.000 BRL",
"-礼品的比例从18%逐渐增加到20%": "- Peratusan hadiah meningkat dari 18% hingga 20%",
"-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "- Di tahap Platinum, tambah nilai anda akan menerima peratusan hadiah yang lebih tinggi. Penguasaan kewangan anda menjadi lebih cemerlang, dengan ganjaran yang banyak.",
"**钻石级别（钻石）**": "**Tahap Berlian (DIAMOND)**",
"-重新加载的总金额：60.001-100.000 BRL": "- Jumlah tambah nilai keseluruhan: 60.001 - 100.000 BRL",
"-礼品比例最高，达到20%": "- Peratusan hadiah tertinggi, mencapai 20%",
"-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "- Ini adalah ketinggian kehormatan, pilihan akhir. Dengan menjadi ahli Berlian, anda akan menikmati peratusan hadiah tertinggi, menjadikan kekayaan anda berkembang pesat, dan impian kewangan anda akan segera tercapai.",
"不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": "Jangan ketinggalan peluang hebat ini. Panjat tangga kekayaan, lihat kekayaan anda berganda. Sertai promosi tambah nilai BRL kami 'Pendakian Kekayaan' dan pastikan sokongan terbaik untuk mencapai matlamat kewangan anda. Perjalanan ke arah kekayaan bermula dengan anda, ganjaran tidak akan berhenti berkembang, kejayaan ada di sisi anda!",
"游戏记录": "Rekod Permainan",
"交易记录": "Rekod Transaksi",
"提交": "Hantar",
"游戏品牌": "Jenama Permainan",
"游戏名称": "Nama Permainan",
"下注时间": "Masa Pertaruhan",
"下注金额": "Jumlah Pertaruhan",
"输赢金额": "Jumlah Menang atau Kalah",
"上一页": "Halaman Sebelumnya",
"下一页": "Halaman Seterusnya",
"申请时间": "Masa Permohonan",
"状态": "Status",
"法规与合作伙伴": "Peraturan dan Rakan Kongsi",
"为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。": "Untuk mendaftar di laman web ini, pengguna mesti menerima terma dan syarat umum. Jika terma dan syarat dikemas kini, pengguna sedia ada boleh memilih untuk berhenti menggunakan produk dan perkhidmatan sebelum kemas kini tersebut berkuat kuasa, iaitu sekurang-kurangnya dua minggu selepas pengumuman kemas kini. Tambet911.com dikendalikan oleh JajajEmmi B.V. dengan nombor pendaftaran 150790 dan alamatnya ialah Abraham Mendez Chumaceiro Boulevard 03, Willemstad, Curacao. Laman web ini dilesenkan dan dikawal selia oleh Curacao Island Electronic Gaming Company dengan nombor lesen 1668/JAZ.",
'您可以使用用户名和密码登录': 'Anda boleh log masuk dengan nama pengguna dan kata laluan anda',
'创建账户': 'Buat akaun',
'银行信息': 'Maklumat Bank',
'名称': 'Nama',
'时间': 'Masa',
'最小': 'Minimum',
'最大': 'Maksimum',
'即时到账': 'Penerimaan Segera',
'选择银行': 'Pilih Bank',
'银行账号': 'Nombor Akaun Bank',
'请输入银行账号': 'Sila masukkan nombor akaun bank anda',
'金额': 'Jumlah',
'支出': 'Pembayaran',
'输入金额': 'Sila masukkan jumlah',
"暂无数据": "Tiada data buat masa ini",
'获奖人': 'Pemenang',
'游戏榜': 'Carta Permainan',
'新游戏榜': 'Carta Permainan Baharu',
'热门游戏榜': 'Peringkat Permainan Popular',
'电子游戏': 'Permainan Elektronik',
'主要余额': 'Baki Utama',
'历史记录': 'Sejarah',
'付款名称': 'Nama Pembayaran',
'费用': 'Kos',
'免费': 'Percuma',
'立即生效': 'Berkuat kuasa serta-merta',
'银行选择': 'Pilihan Bank',
'银行账户': 'Akaun Bank',
'充值金额': 'Jumlah Tambah Nilai',
'收款名称': 'Nama Penerimaan',
'账号类型': 'Jenis Akaun',
'收账账号': 'Nombor Akaun Penerimaan',
'CPF号码': 'Nombor CPF',
'提现密码': 'Kata Laluan Pengeluaran',
'请输入名称': 'Sila masukkan nama',
'请选择类型': 'Sila pilih jenis',
'请输入CPF': 'Sila masukkan CPF',
'请输入提现金额': 'Sila masukkan jumlah pengeluaran',
'请输入正确的参数': 'Sila masukkan parameter yang betul',
"收藏夹":"Kegemaran",
"敬请期待":"Akan Datang",
"用户":"Pengguna",
"玩家":"Pemain",
"时间":"Masa",
"赌场":"Kasino",
"体育运动":"Sukan",
"促销":"Promosi",
"支持/法律":"Sokongan/Perundangan",
"加入我们的社区":"Sertai Komuniti Kami",
"赌场主页":"Laman Utama Kasino",
"插槽":"Slot",
"现场赌场":"Kasino Langsung",
"新版本":"Keluaran Baharu",
"桌面游戏":"Permainan Meja",
"体育之家":"Laman Utama Sukan",
"会员俱乐部":"Kelab VIP",
"优惠促销":"Promosi Istimewa",
"赌博意识":"Kesedaran Perjudian",
"常问问题":"Soalan Lazim",
"条款和条件":"Terma dan Syarat",
"隐私政策":"Dasar Privasi",
"赞助和游戏责任":"Penajaan dan Tanggungjawab Permainan",
"页脚文本":"BetBlitz menetapkan matlamat untuk mencapai dominasi global dalam bidang permainan dalam talian dan pertaruhan, menggunakan teknologi blockchain canggih, dan sentiasa mengutamakan kepuasan pelanggan. Prinsip kepercayaan, integriti, dan keadilan adalah panduan dalam setiap usaha kami.",
"充电时间":"Masa Caj Semula",
"订单号":"Nombor Pesanan",
"充值金额":"Jumlah Tambah Nilai",
"充值方式":"Kaedah Tambah Nilai",
"地位":"Status",
'负责任的博彩': 'Permainan Bertanggungjawab',
'快速链接': 'Pautan Pantas',
'桌上游戏': 'Permainan Meja',
'二十一点': 'Blackjack',
'扑克': 'Poker',
'百家乐': 'Baccarat',
'掷骰子': 'Craps',
'奖金': 'Bonus',
'赌场奖金': 'Bonus Kasino',
'自由旋转': 'Putaran Percuma',
'免费投注': 'Pertaruhan Percuma',
'信息': 'Maklumat',
"":"",
'老虎机游戏':'Permainan Slot',
'赌场游戏':'Permainan Kasino',
'更多游戏':'Lebih Banyak Permainan',
'搜索游戏':'Cari Permainan',
'特色提供商':'Penyedia Unggulan',

  "特色平台": "Platform Unggulan",
  "游戏": "Permainan",
  "乘数": "Pengganda",
  "热的": "Panas",

  "signup": "Daftar",
  "home": "Laman Utama",
  "eGame": "Semua Permainan",
  "lottery": "Loteri",
  "lottery_games": "Permainan Loteri",
  "sports": "Sukan",
  "sbanner1_title": "SISTEM RAKEBACK",
  "sbanner2_title": "PEMBERIAN",
  "sbanner3_title": "BONUS MINGGUAN",
  "sbanner4_title": "HUJAN CHAT",
  "sbanner1_desc": "Sistem fleksibel, dapatkan bonus besar dari rake.",
  "sbanner2_desc": "Lebih tinggi pangkat anda, lebih mengejutkan ia akan menjadi",
  "sbanner3_desc": "Kunjungi kami lebih kerap dan dapatkan bonus!",
  "sbanner4_desc": "Ganjaran secara rawak pemain dalam bilik chat setiap 5 jam",

  "other_info": "Maklumat lain",
  "aboutus": "Tentang Kami",
  "payments": "Pembayaran",
  "terms": "Terma dan Syarat",
  "privacy": "Dasar Privasi",
  "side_bottom_txt": "bertujuan untuk menjadi peneraju global dalam permainan dan pertaruhan dalam talian menggunakan teknologi blockchain terkini, sentiasa meletakkan pelanggan kami di tempat pertama. Kepercayaan, integriti dan keadilan adalah tiga daripada nilai utama kami.",

  "cat1_desc": "Rasai keseronokan peluang dan kekayaan dengan permainan loteri dalam talian kami yang menarik. Uji nasib anda dan menang besar dengan mudah!",
  "cat2_desc": "Nikmati permainan sukan dalam talian kami, sertai pertandingan yang mendebarkan, dan rasai kemenangan secara langsung!",

  "products": "Produk",
  "company": "Syarikat",
  "careers": "Kerjaya",
  "faqs": "Soalan Lazim",
  "contact": "Hubungi Kami",
  "sponsors": "Penaja",
  "winners": "Pemenang",
  "username": "Nama Pengguna",
  "create_acc": "Cipta Akaun",
  "mainBanner_tag1": "DAFTAR & DAPATKAN GANJARAN",
  "mainBanner_tag2": "SEHINGGA",
  "Personal Center" : "Pusat Peribadi"

}
export default my



// WEBPACK FOOTER //
// ./src/utils/lang/config/malay.js